import { FC } from 'react';
import { Check, Lock, MapPin } from 'lucide-react';

interface StepIconProps {
  Icon: FC<{ className?: string }>;
}

const baseClasses =
  'w-8 md:w-12 h-8 md:h-12 rounded-full flex items-center justify-center relative';

export const StepIconCompleted: FC<StepIconProps> = ({ Icon }) => {
  return (
    <div className={`${baseClasses} bg-(--success-S600)`}>
      <Icon className="w-4 h-4 md:w-6 md:h-6 text-(--neutral-white-NW1000)" />
      <div className="absolute -bottom-1 -right-1 w-4 h-4 md:w-5 md:h-5 bg-(--success-S700) rounded-full flex items-center justify-center">
        <Check className="w-2 md:w-3 h-2 md:h-3 text-(--neutral-white-NW1000)" />
      </div>
    </div>
  );
};

export const StepIconLocked: FC<StepIconProps> = ({ Icon }) => {
  return (
    <div
      className={`${baseClasses} bg-(--neutral-black-NB100) border md:border-2 border-(--neutral-black-NB200)`}
    >
      <Icon className="w-4 h-4 md:w-6 md:h-6 text-(--neutral-black-NB500)" />
      <div className="absolute -bottom-1 -right-1 w-4 h-4 md:w-5 md:h-5 bg-(--neutral-black-NB200) border-2 border-(--neutral-white-NW1000) rounded-full flex items-center justify-center">
        <Lock className="w-2 md:w-3 h-2 md:h-3 text-(--neutral-black-NB500) stroke-2" />
      </div>
    </div>
  );
};

export const StepIconPending: FC<StepIconProps> = ({ Icon }) => {
  return (
    <div
      className={`${baseClasses} bg-(--primary-O1000) border md:border-2 border-(--primary-O1000)`}
    >
      <Icon className="w-4 h-4 md:w-6 md:h-6 text-(--neutral-white-NW1000)" />
      <div className="absolute -bottom-2 md:-bottom-1 -right-2 md:-right-1 w-4 h-4 md:w-5 md:h-5 bg-(--neutral-black-NB100) rounded-full flex items-center justify-center">
        <MapPin className="w-2 md:w-3 h-2 md:h-3 text-(--neutral-black-NB600)" />
      </div>
    </div>
  );
};
